/** Operator OpenID Connect sign-in (M29 P2, PID-009): mirror of backend `app/core/constants/operator_oidc.py`.
 *  `backend/tests/core/test_operator_oidc_mirror.py` keeps the two equal. */

export const OIDC_ISSUER_MAX_LENGTH = 2048 as const;
export const OIDC_CLIENT_ID_MAX_LENGTH = 512 as const;
export const OIDC_CLIENT_SECRET_MAX_LENGTH = 1024 as const;
export const OIDC_SCOPES_MAX = 10 as const;
export const OIDC_REQUIRED_SCOPE = "openid" as const;
export const OIDC_DEFAULT_SCOPES = ["openid"] as const;

/** The three facts a launch carries, filled from claims of the verified ID token. */
export const OIDC_CLAIM_MAPPING_FIELDS = ["ref", "tier", "account_status"] as const;
export type OidcMappedField = (typeof OIDC_CLAIM_MAPPING_FIELDS)[number];
export const OIDC_DEFAULT_CLAIM_MAPPING = { ref: "sub", tier: "tier", account_status: "status" } as const;
export const OIDC_CLAIM_NAME_MAX_LENGTH = 515 as const;

/** Query key of the web app sign-in page that carries why a sign-in through the operator's provider ended. */
export const OIDC_ERROR_QUERY = "oidc_error" as const;
export const OIDC_FAILURE_VALUES = ["failed", "unavailable", "framed", "expired", "blocked"] as const;
export type OidcFailure = (typeof OIDC_FAILURE_VALUES)[number];
